module.exports = __webpack_public_path__ + "img/cloud-blue.980c6072.png";